<template>
  <div class="crewHome">
    <iframe
      ref="iframeRef"
      :src="ismSrc"
      width="100%"
      height="100%"
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ismSrc: "",
    };
  },
  mounted() {
    const savedSession = this.saveSessionData();
    let httpUrl = "";
    let token = window.sessionStorage.getItem("otherToken");
    if (process.env.NODE_ENV === "development") {
      httpUrl = "http://test.lanshuimu.com";
    } else {
      httpUrl = "https://www.lanshuimu.com";
    }
    this.ismSrc = httpUrl + "/#!/frame/approve-my_approve?platToken=" + token;
    console.log(this.ismSrc);
    
    this.$refs.iframeRef.addEventListener("load", () => {
      // 恢复会话数据
      this.restoreSessionData(savedSession);
    });
  },
  methods: {
    saveSessionData() {
      const data = {};
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        data[key] = sessionStorage.getItem(key);
      }
      return data;
    },
    restoreSessionData(data) {
      // 先清除所有数据
      // sessionStorage.clear();

      // 恢复保存的数据
      Object.keys(data).forEach((key) => {
        if (key != "token") {
          sessionStorage.setItem(key, data[key]);
        }
      });
    },
  },
};
</script>
